// invoice http service

import { api } from './api.config'

import request from '@/utils/request'

export default {
  buyer: {
    save (data) {
      return request({
        url: api.buyer.save,
        method: 'post',
        data
      })
    }
  },
  seller: {
    getInvoiceDetails (data, params) {
      return request({
        url: api.seller.getInvoiceDetails,
        method: 'get',
        data,
        params,
        defaultCompany: false
      })
    }
  }
}
